import Blocks from "./Blocks"
import Unknown from "../blocks/unknown/main.js"

const convertHtmlToBlocks = function (html) {
	const parser = new DOMParser();
	var doc = parser.parseFromString(html, "text/html");

	return Array.from(doc.querySelectorAll("[data-block]")).map(blockDom => {
		const blockName = blockDom.dataset.block;

		let blockConstructor = Blocks.registeredBlocks.find(blockConstructor => blockConstructor.name === blockName);
		let block;
		if (blockConstructor) {
			block = new blockConstructor(blockDom);
		} else {
			block = new Unknown(blockDom);
		}

		return block;
	})
}

export default convertHtmlToBlocks;